export const blockIconsFileDownloadDone = (
	<span className='material-symbols-outlined'>download_done</span>
);
